export default "__VITE_ASSET__DWp9m50z__"